import { render, staticRenderFns } from "./ProductExcludeInSearchPopupIframe.vue?vue&type=template&id=ec88190e&"
import script from "./ProductExcludeInSearchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductExcludeInSearchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports